/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "@kubb/plugin-client/clients/axios";
import type {
	TokenIssuerLookupV1TokensIssuerLookupPostMutationRequest,
	TokenIssuerLookupV1TokensIssuerLookupPostMutationResponse,
	TokenIssuerLookupV1TokensIssuerLookupPostQueryParams,
	TokenIssuerLookupV1TokensIssuerLookupPost422,
} from "../models/TokenIssuerLookupV1TokensIssuerLookupPost.ts";
import type {
	RequestConfig,
	ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

export const tokenIssuerLookupV1TokensIssuerLookupPostMutationKey = () =>
	[{ url: "/v1/tokens/issuer-lookup" }] as const;

export type TokenIssuerLookupV1TokensIssuerLookupPostMutationKey = ReturnType<
	typeof tokenIssuerLookupV1TokensIssuerLookupPostMutationKey
>;

/**
 * @description Convert issuer public keys to their token identifier/address or vice-versa. Accepts up to 100 items per request.
 * @summary Lookup token ↔ issuer pubkey
 * {@link /v1/tokens/issuer-lookup}
 */
export async function tokenIssuerLookupV1TokensIssuerLookupPostHook(
	params: TokenIssuerLookupV1TokensIssuerLookupPostQueryParams,
	data?: TokenIssuerLookupV1TokensIssuerLookupPostMutationRequest,
	config: Partial<
		RequestConfig<TokenIssuerLookupV1TokensIssuerLookupPostMutationRequest>
	> & { client?: typeof client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<
		TokenIssuerLookupV1TokensIssuerLookupPostMutationResponse,
		ResponseErrorConfig<TokenIssuerLookupV1TokensIssuerLookupPost422>,
		TokenIssuerLookupV1TokensIssuerLookupPostMutationRequest
	>({
		method: "POST",
		url: "/v1/tokens/issuer-lookup",
		baseURL: "https://api.sparkscan.io",
		params,
		data,
		...requestConfig,
	});
	return res.data;
}

/**
 * @description Convert issuer public keys to their token identifier/address or vice-versa. Accepts up to 100 items per request.
 * @summary Lookup token ↔ issuer pubkey
 * {@link /v1/tokens/issuer-lookup}
 */
export function useTokenIssuerLookupV1TokensIssuerLookupPostHook<TContext>(
	options: {
		mutation?: UseMutationOptions<
			TokenIssuerLookupV1TokensIssuerLookupPostMutationResponse,
			ResponseErrorConfig<TokenIssuerLookupV1TokensIssuerLookupPost422>,
			{
				params: TokenIssuerLookupV1TokensIssuerLookupPostQueryParams;
				data?: TokenIssuerLookupV1TokensIssuerLookupPostMutationRequest;
			},
			TContext
		> & { client?: QueryClient };
		client?: Partial<
			RequestConfig<TokenIssuerLookupV1TokensIssuerLookupPostMutationRequest>
		> & { client?: typeof client };
	} = {},
) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey =
		mutationOptions.mutationKey ??
		tokenIssuerLookupV1TokensIssuerLookupPostMutationKey();

	return useMutation<
		TokenIssuerLookupV1TokensIssuerLookupPostMutationResponse,
		ResponseErrorConfig<TokenIssuerLookupV1TokensIssuerLookupPost422>,
		{
			params: TokenIssuerLookupV1TokensIssuerLookupPostQueryParams;
			data?: TokenIssuerLookupV1TokensIssuerLookupPostMutationRequest;
		},
		TContext
	>(
		{
			mutationFn: async ({ params, data }) => {
				return tokenIssuerLookupV1TokensIssuerLookupPostHook(
					params,
					data,
					config,
				);
			},
			mutationKey,
			...mutationOptions,
		},
		queryClient,
	);
}
